module.exports = __webpack_public_path__ + "static/media/location-king-c5002a.40c5e8a6.svg";